import { render, staticRenderFns } from "./Investors.vue?vue&type=template&id=bc38ff0c&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38ff0c",
  null
  
)

export default component.exports